// extracted by mini-css-extract-plugin
module.exports = {"TabS5":"Tablet_TabS5__3UC6L"};